export class AdminSendMessageDto {
  title: string;
  message: string;
  phone: string;
}
